export default class ChatMessage {
    constructor({ role, content, threadId = null, timestamp = new Date().toISOString(), 
      isError = false, isStreaming = false, sessionId =null, id = null, type = ChatType.CHAT, reportId }) {
      this.role = role; // 'user' or 'assistant'
      this.content = content; // Message text
      this.threadId = threadId; // Optional thread ID
      this.timestamp = timestamp; // Message timestamp
      this.isError = isError; // Error flag
      this.isStreaming = isStreaming; // Streaming flag
      this.sessionId = sessionId; // Session ID
      this.id = id; // Message ID
      this.type = type; // Message type
      this.reportId = reportId; // Report ID In case of Report

    }
  
    /**
     * Static method to create a ChatMessage instance from JSON data.
     * @param {Object} json - The JSON object containing message data.
     * @returns {ChatMessage} - A ChatMessage instance.
     */
    static fromJson(json) {
      if (!json || typeof json !== 'object') {
        throw new Error('Invalid JSON for ChatMessage');
      }

      let hasError = false;
      let content = json.content || '';
      try{
       const contentJson = JSON.parse(json.content);
       if(contentJson.error){
        hasError = true;
        content = contentJson.error;
       }
      }catch(ex){
      }

      
      return new ChatMessage({
        role: json.role,
        content: content,
        threadId: json.threadId || null,
        timestamp: json.timestamp || new Date().toISOString(),
        isError: hasError,
        isStreaming: json.isStreaming || false,
        sessionId: json.sessionId || null,
        type: json.type || ChatType.CHAT,
        id: json.messageId || null,
        reportId: json.reportId || null,
      });
    }
  
    /**
     * Method to convert the ChatMessage instance back to JSON.
     * @returns {Object} - JSON representation of the ChatMessage.
     */
    toJson() {
      return {
        role: this.role,
        content: this.content,
        threadId: this.threadId,
        timestamp: this.timestamp,
        isError: this.isError,
        isStreaming: this.isStreaming,
        sessionId: this.sessionId,
        type: this.type,
        reportId: this.reportId,
      };
    }
  }

  export const MessageRole = {
    USER: 'user',
    ASSISTANT: 'assistant',
  }

  export const ChatType = {
    CHAT: 'chat',
    REPORT: 'report',
  }
